import { Component, EventEmitter, Input, Output, signal, OnInit, OnDestroy } from '@angular/core';
import { ListTableColumnComponent } from '../list-table-column/list-table-column.component';
import { CommonModule, DatePipe, PercentPipe } from '@angular/common';
import { TranslatePipe } from '../../directives/TranslatePipe';
import { BreakpointObserver, Breakpoints, LayoutModule, BreakpointState } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TimeZoneIconComponent } from '../../nested-components/timezone-icon/timezone-icon.component';

@Component({
  selector: 'app-list-stack',
  templateUrl: './list-stack.component.html',
  standalone: true,
  imports: [CommonModule, DatePipe, PercentPipe, TranslatePipe, LayoutModule, TimeZoneIconComponent]
})
export class ListStackComponent implements OnInit, OnDestroy {
  @Input()
  selectedId: number | string | null = null;

  @Input()
  items: any[] = [];

  @Input()
  columns: ListTableColumnComponent[] = [];

  // Icone d'horloge : fuseau d'apres le site de CHAQUE ligne, comme la table.
  @Input() fuseauxParSite: Map<number, string> = new Map();

  @Output()
  itemSelected = new EventEmitter<any>();

  isSmallScreen = signal<boolean>(false);
  private destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
    this.breakpointObserver.observe([
      '(max-width: 500px)'
    ]).pipe(takeUntil(this.destroy$))
      .subscribe((result: BreakpointState) => {
        this.isSmallScreen.set(result.matches);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onItemSelected(item: any): void {
    this.itemSelected.emit(item);
  }

  // Fuseau du site de CETTE ligne, ou null si son decalage est celui du lecteur.
  fuseauDeLigne(item: any): string | null {
    const fk = item?.fK_PointOfService;
    if (fk == null) return null;
    return this.fuseauxParSite.get(Number(fk)) ?? null;
  }

  getFieldValue(item: any, column: ListTableColumnComponent): any {
    if (!item || !column || !column.key) {
      return '';
    }

    // Handle nested properties
    const fieldNames = column.key.split('.');
    let value = item;
    for (const fieldName of fieldNames) {
      if (value === null || value === undefined) {
        return '';
      }
      value = value[fieldName];
    }
    return value;
  }
}
